import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'
import { withDropdown } from 'lib/with-hoc'
import { ProfileImage } from 'quick-quote/components'
import { getAppConfig } from '../../deploy-env/app-config'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router-dom'

export const LoginDropdown = ({ dropdownOpen, toggle, icon, user, logoutRequest, history }) => {
  const handleProfileLink = (e) => {
    toggle()
    e.preventDefault()
    history.push(`/authorize/info`)
    //window.open(`http://localhost:8000/authorize/info`, '_self')
  }

  const handleLogoutLink = (e) => {
    toggle()
    e.preventDefault()
    logoutRequest()
  }

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggle} data-dropdownopen={dropdownOpen}>
      <DropdownToggle>
        <ProfileImage profile={user.profile} />
      </DropdownToggle>
      <DropdownMenu right>
        <span
          className="az-agent-code"
          id="dt-profile"
          data-tag={`${user.profile.name} (${user.profile.agent_code || ''})`}
        />
        <Link className="dropdown-item-profile" to="/profile" onClick={handleProfileLink}>
          บัญชีผู้ใช้งาน
        </Link>
        <DropdownItem divider />
        <Link className="dropdown-item-logout" to="/logout" onClick={handleLogoutLink}>
          ออกจากระบบ
        </Link>
      </DropdownMenu>
    </Dropdown>
  )
}

export default withDropdown(withRouter(LoginDropdown))
